import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import styles from './WinnerStyles.module.css';
import hum from '../../assets/images/hum.png';
import { useBroadcast } from '../../hooks/useBroadcast';
import confetti from '../../assets/images/confetti.gif';

function Winner({ winnerFontSize }) {
  const { currentMessage } = useBroadcast();

  const errorHandler = (e) => {
    e.target.src = hum;
  };

  const confettiRef = useRef(null);

  useEffect(() => {
    let idTimeout = '';
    if (confettiRef.current) {
      idTimeout = setTimeout(() => {
        confettiRef.current.style.display = 'block';
      }, 1000);
    }
    return () => {
      clearTimeout(idTimeout);
    };
  }, [confettiRef]);

  const size = 46.75;
  const BORDER = 0.9;
  const radius = size / 2;

  return (
    <div>
      {currentMessage && (
        <div
          className={styles.winnerWrapper}
          key={currentMessage?.message.author}>
          <motion.div
            initial={{ opacity: 0, transform: 'scale(0)' }}
            animate={{ opacity: 1, transform: 'scale(0.9)' }}
            exit={{ opacity: 0, transform: 'scale(0)' }}
            transition={{ duration: 0.7 }}
            className={styles.imgBlock}>
            <svg
              width={`${size}rem`}
              height={`${size}rem`}
              className={styles.borderAvatar}>
              <circle
                cx={`${radius}rem`}
                cy={`${radius}rem`}
                r={`${radius * BORDER}rem`}
                stroke="#fff"
                strokeWidth={'0.52rem'}
                fill="none"
              />
            </svg>
            <img
              src={
                (currentMessage?.message.image &&
                  currentMessage?.message.image !== '1' &&
                  currentMessage?.message.image) ||
                hum
              }
              alt="Фото"
              onError={errorHandler}
            />
          </motion.div>
          <motion.div
            initial={{ y: '50vh' }}
            animate={{ y: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.7 }}
            className={styles.winnerTitle}
            style={{ fontSize: `${winnerFontSize}rem` }}>
            <div>Победитель</div>
          </motion.div>
          <motion.div
            initial={{ y: '50vh' }}
            animate={{ y: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5, delay: 0.5 }}
            className={styles.winnerName}
            style={{ fontSize: `${winnerFontSize}rem` }}>
            <div>{currentMessage?.message.author}</div>
          </motion.div>
        </div>
      )}
      <img
        className={styles.confetti__img}
        src={confetti}
        ref={confettiRef}
        alt="confetti"
      />
    </div>
  );
}

export default Winner;
